export function useQHeadful() {
  function watchTitle(newTitle) {
    // Used for screen reader (force the focus in the head of the page with the title of the loaded page)
    const pageTitle = document.getElementById('title-page')
    if (pageTitle) {
      pageTitle.innerHTML = newTitle
      pageTitle.focus()
    }

    // Used for all users
    document.title = newTitle
  }

  return {
    watchTitle
  }
}
